import { ModelRow } from "@mcleod/core";
import { AutogenLayoutImportFileExceptionTable } from "./autogen/AutogenLayoutImportFileExceptionTable";

export class ImportFileExceptionTable extends AutogenLayoutImportFileExceptionTable {
    public get tabCaption(): string {
        return "Exceptions";        
    }

    public set data(data: any[]) {
        const modelRowArray: ModelRow[] = [];
        data?.forEach(row => {
            const modelRow = new ModelRow("lme/general/dataimport/import-file-exception", false, { ...row });
            modelRowArray.push(modelRow);
        });
        this.sourceImportFileException.data = modelRowArray;
        this.sourceImportFileException.displayDataInBoundComponents();
    }
}
